import React from 'react';
import classNames from 'classnames'
import dateFormat from 'dateformat'
import * as linkify from 'linkifyjs';
import hashtag from 'linkifyjs/plugins/hashtag';
import Linkify from 'linkifyjs/react';

import linkifyHtml from 'linkifyjs/html';

//hashtag(linkifyHtml);

const Comment = ({ keyLine, text, date, user, userObj }) => {
    const tagClass = classNames({
        //'tag': true,
        //'active': active
    });

    const commentClass = classNames({
        'comment__element_new': userObj.commentsTime[keyLine].oldDate < date,
        'comment__element': true
    });

    const options = {
        ignoreTags: [
            'style',
        ],
    }
    return (
        <div className={commentClass}>
            {
                user && (
                    <div className="comment_name" style={{color: user.color}}>{user.name}</div>
                )
            }
                    <div className="comment__text" dangerouslySetInnerHTML={{ __html: text }}>

                    </div>
            <div className="comment__block-bottom">
                {/*<div className="comment__tag tag_type-1">Верстка</div>*/}
                <div className="comment__date">{ dateFormat(date, "dddd, mmmm dS, yyyy, h:MM:ss TT") }</div>
            </div>
        </div>
    )
}




export default Comment;


// WEBPACK FOOTER //
// ./src/components/Comment.js